export default "__VITE_ASSET__BddLxwq9__"